import { motion } from "framer-motion";

export const Page = ({ children, className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 14, filter: "blur(6px)" }} animate={{ opacity: 1, y: 0, filter: "blur(0px)" }} exit={{ opacity: 0, y: -8, filter: "blur(4px)" }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} className={className}>
    {children}
  </motion.div>
);

export const Section = ({ eyebrow, title, subtitle, children, className = "", right, id }) => (
  <section id={id} className={`mx-auto max-w-7xl px-4 sm:px-6 scroll-mt-24 ${className}`}>
    {(eyebrow || title) && (
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div className="max-w-2xl">
          {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
          {title && <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#020B18]">{title}</h2>}
          {subtitle && <p className="mt-3 text-base text-[#475569] leading-relaxed">{subtitle}</p>}
        </div>
        {right}
      </div>
    )}
    {children}
  </section>
);

export const DemoBadge = () => (
  <span className="inline-flex items-center rounded-full bg-amber-50 text-amber-700 border border-amber-200 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider" data-testid="demo-badge">Demo</span>
);
